import {Injectable} from '@angular/core';
import * as go from 'gojs';
import {AppConstants, LabelConstants} from './app-constants';
import {FolioEnums} from './folio-enums';
import {WorkshopActivity} from '../modules/workshop/models/workshop-model';
import * as moment from 'moment';
import {BehaviorSubject} from 'rxjs';
import {environment} from 'src/environments/environment';
import {IUserNew} from '../models/user';

interface ISpinner {
    visible: boolean;
    text?: string;
}
@Injectable({
    providedIn: 'root'
})
export class FolioHelperService {
    readonly MY_CONSTANT = LabelConstants;

    // user name
    private username = new BehaviorSubject('Folio');
    fetchedUserName = this.username.asObservable();
    // user name END

    // Spinner Service
    private spinnerData: ISpinner = { visible: true };
    private spinnerVisibility = new BehaviorSubject(this.spinnerData);
    showSpinner = this.spinnerVisibility.asObservable();

    private userData = new BehaviorSubject<IUserNew[]>([]);
    usersData = this.userData.asObservable();
    private teamUserData = new BehaviorSubject<IUserNew[]>([]);
    teamUsersData = this.teamUserData.asObservable();

    private totalEffectsCount = 0;
    private toatlCausesCount = 0;
    // Spinner Service END


    constructor() { }

    // fetch data from local storage
    saveDataInLocalStorage(withKey: string, andData: object) {
        localStorage.setItem(withKey, JSON.stringify(andData));
    }

    // save data to local storage
    fetchDataFromLocalStorage(withKey: string) {
        if (withKey.includes('undefined')) {
            return;
        }
        return JSON.parse(localStorage.getItem(withKey));
    }

    cognitoTokensKey(userName: string, name: string) {
        if (name === 'LastAuthUser') {
            return 'CognitoIdentityServiceProvider.' + environment.paramAppsynUserPoolWebClientId + '.' + name;
        } else {
            return 'CognitoIdentityServiceProvider.' + environment.paramAppsynUserPoolWebClientId + '.' + userName + '.' + name;
        }
    }

    fetchUserName(): void {
        this.username.next(localStorage.getItem('CognitoIdentityServiceProvider.' +
            environment.paramAppsynUserPoolWebClientId + '.LastAuthUser'));
    }

    setSpinnerVisible(visible: boolean, text?: string): void {
        setTimeout(() => {
            this.spinnerVisibility.next({ visible, text }); // By setting this value, "showSpinner" observable property will be updated.
        }, 100);
    }

    // filter search data
    filterItems(array, searchTerm) {
        if (!array) {
            return;
        }
        return array.filter(item => {
            return item.USERNAME.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
        });
    }

    fetchAWSCognitoDetails(withKey: string) {
        const lastAuthUser = localStorage.getItem('CognitoIdentityServiceProvider.' +
            environment.paramAppsynUserPoolWebClientId + '.LastAuthUser');
        // CognitoIdentityServiceProvider.16nbs81qe7gr8c1j9tb5pu0v42.LastAuthUser
        const key = 'CognitoIdentityServiceProvider.' + environment.paramAppsynUserPoolWebClientId + '.' + lastAuthUser + '.' + withKey;
        return this.fetchDataFromLocalStorage(key);
    }

    reconstituteNodeData(nodesData: any) {
        const nodeData = nodesData.nodes;
        nodeData.filter(node => {
            return node.type === AppConstants.PARAM_GO_JS_NODE_TYPE_EFFECT ? node.color = AppConstants.PARAM_GO_JS_EFFECT_COLOR :
                (node.type === AppConstants.PARAM_GO_JS_NODE_TYPE_CAUSE ? node.color = AppConstants.PARAM_GO_JS_CAUSE_COLOR :
                    node.color = AppConstants.PARAM_GO_JS_FOCAL_PROBLEM_COLOR);
        });
        return nodesData;
    }


    // Workshop

    // GoJS tree RELATED...

    calculateDistance(data: { nodes: any; }, node: { key: any; }) {
        let effectslevels = [];
        let causeslevels = [];
        let siblingEffectLevels = [];
        let siblingCauseLevels = [];
        let siblingHighNodes;
        let totalCauses = [];
        let totaleffects = [];
        const sortedData = data.nodes.sort((a, b) =>
            a.hirLevel > b.hirLevel ? -1 : 1
        );
        for (let i = 1; i <= sortedData[0].hirLevel; i++) {
            effectslevels.push({
                type: 'Effect',
                level: i,
                value: data.nodes.filter(
                    a =>
                        a.hirLevel === i &&
                        a.type === 'Effect' &&
                        a.siblingLevel === node['siblingLevel']
                ).length
            });
            causeslevels.push({
                type: 'Cause',
                level: i,
                value: data.nodes.filter(
                    a =>
                        a.hirLevel === i &&
                        a.type === 'Cause' &&
                        a.siblingLevel === node['siblingLevel']
                ).length
            });
        }
        effectslevels = effectslevels.sort((a, b) => (a.value > b.value ? -1 : 1));
        causeslevels = causeslevels.sort((a, b) => (a.value > b.value ? -1 : 1));

        let parentHighNodes: any;
        if (effectslevels.length > 0 && causeslevels.length > 0) {
            parentHighNodes =
                effectslevels[0].value > causeslevels[0].value
                    ? effectslevels[0]
                    : causeslevels[0];
        }

        // const parentHighNodes =
        //     effectslevels[0].value > causeslevels[0].value
        //         ? effectslevels[0]
        //         : causeslevels[0];
        const isSibling = data.nodes.filter(
            a => a.type === 'Sibling' && a.parent === node.key
        );
        if (isSibling.length === 1) {
            for (let i = 1; i <= sortedData[0].hirLevel; i++) {
                siblingEffectLevels.push({
                    type: 'Effect',
                    level: i,
                    value: data.nodes.filter(
                        a =>
                            a.hirLevel === i &&
                            a.type === 'Effect' &&
                            a.siblingLevel === isSibling[0].siblingLevel
                    ).length
                });
                siblingCauseLevels.push({
                    type: 'Cause',
                    level: i,
                    value: data.nodes.filter(
                        a =>
                            a.hirLevel === i &&
                            a.type === 'Cause' &&
                            a.siblingLevel === isSibling[0].siblingLevel
                    ).length
                });
            }
            siblingEffectLevels = siblingEffectLevels.sort((a, b) =>
                a.value > b.value ? -1 : 1
            );

            siblingCauseLevels = siblingCauseLevels.sort((a, b) =>
                a.value > b.value ? -1 : 1
            );

            if (siblingEffectLevels.length > 0 && siblingCauseLevels.length > 0) {
                siblingHighNodes =
                    siblingEffectLevels[0].value > siblingCauseLevels[0].value
                        ? siblingEffectLevels[0]
                        : siblingCauseLevels[0];
            } else if (siblingEffectLevels.length > 0) {
                siblingHighNodes = siblingEffectLevels[0];
            } else if (siblingCauseLevels.length > 0) {
                siblingHighNodes = siblingCauseLevels[0];
            }
            effectslevels = effectslevels.sort((a, b) =>
                a.level > b.level ? 1 : -1
            );
            causeslevels = causeslevels.sort((a, b) => (a.level > b.level ? 1 : -1));
            siblingEffectLevels = siblingEffectLevels.sort((a, b) =>
                a.level > b.level ? 1 : -1
            );
            siblingCauseLevels = siblingCauseLevels.sort((a, b) =>
                a.level > b.level ? 1 : -1
            );
            for (let j = 0; j < sortedData[0].hirLevel; j++) {
                totalCauses.push({
                    type: 'Effect',
                    level: j,
                    value: siblingCauseLevels[j].value + causeslevels[j].value
                });
                totaleffects.push({
                    type: 'Effect',
                    level: j,
                    value: siblingEffectLevels[j].value + effectslevels[j].value
                });
            }
            totalCauses = totalCauses.sort((a, b) => (a.value > b.value ? -1 : 1));
            totaleffects = totaleffects.sort((a, b) => (a.value > b.value ? -1 : 1));
        }

        let highLevel: any;
        if (siblingHighNodes) {
            highLevel =
                totalCauses[0].value > totaleffects[0].value
                    ? totalCauses[0].value
                    : totaleffects[0].value;
        } else {
            // highLevel = parentHighNodes.value;
            if (parentHighNodes) {
                highLevel = parentHighNodes.value;
            } else {
                highLevel = 0;
            }
        }
        const totalCount = Number(highLevel) + 2;
        return totalCount * 200;
    }

    nodeButtonsCss(nodeType) {
        const fillColor = nodeType === FolioEnums.gojsNodeTypes.EFFECT ? AppConstants.PARAM_GO_JS_EFFECT_COLOR :
            (nodeType === FolioEnums.gojsNodeTypes.CAUSE ? AppConstants.PARAM_GO_JS_CAUSE_COLOR :
                AppConstants.PARAM_GO_JS_FOCAL_PROBLEM_COLOR);

        const btnAlignment = nodeType === FolioEnums.gojsNodeTypes.EFFECT ? go.Spot.Top :
            (nodeType === FolioEnums.gojsNodeTypes.CAUSE ? go.Spot.Bottom : go.Spot.Left);

        const btnAlignmentFocus = nodeType === FolioEnums.gojsNodeTypes.EFFECT ? go.Spot.Bottom :
            (nodeType === FolioEnums.gojsNodeTypes.CAUSE ? go.Spot.Top : go.Spot.Right);

        return {
            alignment: btnAlignment,
            alignmentFocus: btnAlignmentFocus,
            'ButtonBorder.fill': fillColor,
            'ButtonBorder.stroke': fillColor,
            _buttonFillOver: fillColor,
            _buttonStrokeOver: fillColor,
            cursor: 'pointer',
            width: 25,
            padding: nodeType === FolioEnums.gojsNodeTypes.EFFECT ? go.Margin.parse('30 0 0 5') : 0
        };
    }
    // CSS for buttons around the node

    separatePartsByLayout(diagram, leftParts, rightParts, rootnode, newParts) {
        if (diagram.findNodeForKey) {
            const root = diagram.findNodeForKey(rootnode);
            if (root === null) {
                return;
            }
            leftParts.add(root);
            rightParts.add(root);
            newParts.add(root);
            root.findTreeChildrenNodes().each((child) => {
                const dir = child.data.dir;
                let coll;
                if (dir === 'left') {
                    coll = leftParts;
                } else if (dir === 'right') {
                    coll = rightParts;
                } else if (dir !== 'root') {
                    coll = newParts;
                }
                coll.addAll(child.findTreeParts());
                coll.add(child.findTreeParentLink());
            });
        }
    }

    // Double tree layout

    doubleTreeLayout(data, diagram) {
        const $$: any = go.GraphObject.make;
        data.nodes.forEach(obj => {
            if (obj.type === 'parent' || obj.type === 'Sibling') {
                const leftParts: any = new go.Set();
                const rightParts: any = new go.Set();
                const newParts: any = new go.Set();

                const layerSpacing = this.calculateDistance(data, obj);
                this.totalEffectsCount = 0;
                this.toatlCausesCount = 0;

                this.separatePartsByLayout(diagram, leftParts, rightParts, obj.key, newParts);

                const layout1 = $$(go.TreeLayout, {
                    angle: 90,
                    arrangement: go.TreeLayout.ArrangementFixedRoots
                });
                const layout2 = $$(go.TreeLayout, {
                    angle: 270,
                    arrangement: go.TreeLayout.ArrangementFixedRoots
                });
                const layout3 = $$(go.TreeLayout, {
                    angle: 180,
                    arrangement: go.TreeLayout.ArrangementFixedRoots,
                    layerSpacing
                });
                layout1.doLayout(leftParts);
                layout2.doLayout(rightParts);
                layout3.doLayout(newParts);
            }
        });
    }
    // Double tree layout END

    // Tooltip ...
    showTheTooltip($$, nodeType: number) {
        return {
            toolTip: $$(
                'ToolTip',
                $$(go.TextBlock, nodeType === FolioEnums.gojsNodeTypes.EFFECT ? 'Add Effect' :
                    (nodeType === FolioEnums.gojsNodeTypes.CAUSE ? 'Add Cause' : 'Add Sibling'))
            )
        };
    }
    // Tooltip END

    calculateTheDuration(activity: WorkshopActivity) {
        const startTime = moment(activity.ACTUAL_START_TIME, 'HH:mm:ss');
        const endTime = moment(activity.ACTUAL_END_TIME, 'HH:mm:ss');

        const timeDifference = moment.utc(endTime.diff(moment(startTime)));

        const hrs = moment(timeDifference, 'HH:mm:ss').hours();
        const mins = moment(timeDifference, 'HH:mm:ss').minutes();
        const secs = moment(timeDifference, 'HH:mm:ss').seconds();

        let duration = '00:00:00';
        const durationCheck = endTime.diff(moment(startTime));
        if (durationCheck > 0) {
            duration = `${hrs < 10 ? '0' + hrs : hrs}:${mins < 10 ? '0' + mins : mins}:${secs < 10 ? '0' + secs : secs}`;
        }

        return duration;
    }
    //


    // gojsText block
    nodeTextBlock($$) {
        return $$(
            go.TextBlock,
            this.textStyle(),
            {
                font: '15px Segoe UI,sans-serif',
                overflow: go.TextBlock.OverflowEllipsis,
                verticalAlignment: go.Spot.Top,
                alignment: go.Spot.Center,
                maxLines: 3,
                // text: 'alignment: center',
                editable: true,
                isMultiline: true,
                maxSize: new go.Size(200, 90),
                // minSize: new go.Size(130, 40),
                mouseHover: (e, obj: any) => {
                    obj.text =
                        obj.text.length === 0 ? (obj.text = 'Add text here') : obj.text;
                },
                mouseLeave: (e, obj: any) => {
                    obj.text =
                        obj.text === 'Add text here' ? (obj.text = '') : obj.text;
                }

            },
            new go.Binding('text', 'name').makeTwoWay(),
            // add this --> for tool tips
            {
                toolTip: $$(
                    'ToolTip',
                    $$(go.TextBlock,
                        { margin: 0, overflow: go.TextBlock.OverflowEllipsis, width: 250 },
                        new go.Binding('text', 'name'),
                        new go.Binding('visible', '', (node) => {
                            return node.name.length !== 0;
                        }),
                    )
                ),
            }
        );
    }
    textStyle() {
        return { font: '10pt  Segoe UI,sans-serif', stroke: 'white', margin: 5 };
    }
    // GOJS textblock END

    // GoJS tree RELATED END...

    setAllUsers(userData: IUserNew[]) {
        this.userData.next(userData);
    }

    setTeamUsers(usersData: IUserNew[]) {
        this.teamUserData.next(usersData);
    }
}
